var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("input", {
    directives: [
      {
        name: "model",
        rawName: "v-model",
        value: _vm.currentValue,
        expression: "currentValue"
      }
    ],
    staticClass: "search-input input--text searchbar",
    attrs: {
      "aria-label": "Search",
      name: "q",
      placeholder: _vm.placeholder,
      type: "text",
      id: "searchq",
      maxlength: "50",
      content: "width=device-width, initial-scale=1.0",
      autocomplete: _vm.autocomplete
    },
    domProps: { value: _vm.currentValue },
    on: {
      keyup: function($event) {
        return _vm.$emit("keyup")
      },
      focus: function($event) {
        return _vm.$emit("focus")
      },
      input: function($event) {
        if ($event.target.composing) {
          return
        }
        _vm.currentValue = $event.target.value
      }
    }
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }